module.exports = __webpack_public_path__ + "img/jolion.eea8fad6.jpeg";